<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('users.edit.title')"
        )

        v-container.grid-list-lg(fluid)
            v-layout(raw wrap)
                v-flex(xs12 md6)
                    div.padderRight.mb-3

                        // Form title
                        title-component(type="h4" :title="$t('users.edit.subtitle')")

                        // Skeleton form — shown while users.read is in
                        // flight so the page doesn't flash empty/stale
                        // fields before real data arrives.
                        div.formSkeleton(v-if="isLoading")
                            div.formSkeleton__field(v-for="n in 7" :key="`edit-skel-${n}`")
                                div.formSkeleton__label.shimmer
                                div.formSkeleton__input.shimmer

                        // Edit form
                        edit-form(v-else ref="form")

                v-flex(xs12 md6)
                    div.padderLeft.mb-3
                        title-component(type="h4" :title="$t('users.edit.settings.title')")

                        //Account settings
                        account-settings

                v-flex(xs12)

                    // Horizontal line
                    separator-component

                    div.controls

                        div

                            // Cancel button
                            button-component.ml-0(
                                :action="cancel"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="grey"
                                large
                                outline
                            ) {{ $t('defaultButtons.cancel') }}

                        div

                            // Submit button
                            button-component.mr-0.submit(
                                :action="submit"
                                :isLoading="isLoading"
                                :disabled="isLoading"
                                color="primary"
                                large
                            ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../../Layout/Layout';
    import AccountSettings from './AccountSettings';
    import EditForm from './EditForm';
    import VueTypes from 'vue-types';
    import Button from '~components/Button';
    import Separator from '~components/Title';
    import Title from '~components/Separator';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            AccountSettings,
            EditForm,
            ButtonComponent: Button,
            SeparatorComponent: Separator,
            TitleComponent: Title
        },
        props: {
            id: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('users', ['isLoading'])
        },
        beforeMount() {
            this.read(this.id);
        },
        methods: {
            ...mapActions('users', ['read', 'cancel']),

            /**
             * Update business account
             */
            submit() {
                this.$refs.form.submitForm();
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    // Skeleton form shown while users.read is in flight. Geometry
    // mirrors the v-text-field labels + outlined inputs in EditForm
    // so swapping placeholders for real fields doesn't shift layout.
    .formSkeleton__field
        margin-bottom: 18px

    .formSkeleton__label
        height: 12px
        width: 30%
        border-radius: 4px
        margin-bottom: 8px

    .formSkeleton__input
        height: 56px
        border-radius: 4px

    .shimmer
        position: relative
        overflow: hidden
        background-color: rgba(0, 0, 0, 0.08)

        &:after
            content: ''
            position: absolute
            top: 0
            left: 0
            right: 0
            bottom: 0
            transform: translateX(-100%)
            background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.5),
                transparent
            )
            animation: shimmer 1.4s infinite

    @keyframes shimmer
        100%
            transform: translateX(100%)

    @media screen and (min-width: $grid-breakpoints.md)
        .padderRight
            padding-right: 20px

        .padderLeft
            padding-left: 20px
</style>
